"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyFilesChange = void 0;
const actions_1 = require("./constant/actions");
const errors_1 = require("./constant/errors");
/**
 * @function reducer - manages the state of FileUpload
 * @param files
 * @param action.type
 * @param action.payload
 */
const reducer = (files, { type, payload }) => {
    const idx = !Array.isArray(files)
        ? -1
        : files.findIndex(f => payload.id === f.id);
    switch (type) {
        case actions_1.ADD_FILES:
            return [...files, ...payload.mergedFiles];
        case actions_1.REMOVE_FILE:
            return [...files.filter(p => p.id !== payload.id)];
        case actions_1.PROGRESS:
            if (idx === -1)
                return files;
            const fileUploading = {
                ...files[idx],
                uploading: true,
                uploadPercent: payload.percentage
            };
            return [...files.slice(0, idx), fileUploading, ...files.slice(idx + 1)];
        case actions_1.ERROR:
            if (idx === -1)
                return files;
            const fileError = {
                ...files[idx],
                error: true,
                errorType: errors_1.ERROR_TYPE_DEFAULT
            };
            return [...files.slice(0, idx), fileError, ...files.slice(idx + 1)];
        case actions_1.SUCCESS:
            if (idx === -1)
                return files;
            const fileSuccess = {
                ...payload.file,
                uploading: false,
                error: false
            };
            return [...files.slice(0, idx), fileSuccess, ...files.slice(idx + 1)];
        default:
            return files;
    }
};
/**
 * @function applyFilesChange - apply an action to a list of files and call the onChange callback with the new set of files
 * @param files
 * @param action
 * @param onChange
 */
const applyFilesChange = (files, action, onChange) => {
    const newFiles = reducer(files, action);
    onChange(newFiles);
};
exports.applyFilesChange = applyFilesChange;
//# sourceMappingURL=reducer.js.map